import React, {Component} from 'react';

class RewardChart extends Component {
  static getCoordinatesForPercent(percent) {
    const x = Math.cos(2 * Math.PI * percent);
    const y = Math.sin(2 * Math.PI * percent);
    return [x, y];
  }

  render() {
    const paths = [];
    let cumulativePercent = 0;
    const slices = [
      {
        key: 'staff-reward-percent',
        percent: this.props.staffRewardsPercent,
        color: '#70bc4f'
      },
      {
        key: 'personal-reward-percent',
        percent: this.props.personalRewardsPercent,
        color: '#d80c47'
      },
    ];

    slices.forEach((slice) => {
      const [startX, startY] = RewardChart.getCoordinatesForPercent(cumulativePercent);

      cumulativePercent += slice.percent;

      const [endX, endY] = RewardChart.getCoordinatesForPercent(cumulativePercent);

      const largeArcFlag = slice.percent > 0.5 ? 1 : 0;

      const pathData = [
        `M ${startX} ${startY}`, // Move
        `A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY}`, // Arc
        'L 0 0', // Line
      ].join(' ');

      paths.push(<path d={pathData} fill={slice.color} key={slice.key}/>);
    });

    return (
      <svg
        className="reward-char"
        height="150px"
        style={{transform: 'rotate(-90deg)'}}
        version="1.1"
        viewBox="-1 -1 2 2"
        width="150px"
        xmlns="http://www.w3.org/2000/svg"
      >
        {paths}
      </svg>
    );
  }
}

export default RewardChart;



// WEBPACK FOOTER //
// ./src/components/common/outlet/reward-chart.jsx